import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheck, X } from 'lucide-react';
import { salesNotifications } from '../data/salesNotifications';
import { HERO_IMAGE as BIBLE_COVER } from '../utils/resourceHints';
const FIRST_DELAY = 6000;
const VISIBLE_MS = 6500;
const GAP_MS = 9000;
export function SalesNotifications() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    let nextTimer: number;
    const showTimer = window.setTimeout(() => {
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        nextTimer = window.setTimeout(() => {
          setIndex(current => (current + 1) % salesNotifications.length);
        }, 600);
      }, VISIBLE_MS);
    }, index === 0 ? FIRST_DELAY : GAP_MS);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(hideTimer);
      window.clearTimeout(nextTimer);
    };
  }, [index, dismissed]);
  const item = salesNotifications[index];
  return <AnimatePresence data-id="element-160" data-mp="3kacssejuowih">
      {visible && !dismissed ? <motion.div key={item.id} role="status" aria-live="polite" initial={{
      opacity: 0,
      x: -28,
      y: 10
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -28,
      y: 10
    }} transition={{
      type: 'spring',
      stiffness: 280,
      damping: 26
    }} className="fixed bottom-[84px] left-3 z-50 w-[19rem] max-w-[calc(100vw-1.5rem)] overflow-hidden rounded-xl border border-gold/25 bg-[linear-gradient(180deg,#121216,#0b0b0f)] p-3 shadow-[0_18px_44px_rgba(0,0,0,0.7)] sm:left-5 lg:bottom-[92px] lg:left-[264px]" data-id="element-161" data-mp="35iuhuv5uls5z">
          <div className="flex items-center gap-3" data-id="element-162" data-mp="kug42a77h00p">
            <div className="flex-shrink-0 rounded-md bg-white p-1" data-id="element-163" data-mp="pshnwxcgh3d8">
              <img src={BIBLE_COVER} alt="" aria-hidden="true" loading="lazy" decoding="async" width={36} height={48} className="h-12 w-9 rounded-[2px] object-cover object-top" data-id="element-164" data-mp="prq4ekw4uw3b" />
            </div>

            <div className="min-w-0 flex-1" data-id="element-165" data-mp="9ebgrdqll9vk">
              <p className="flex items-center gap-1.5 font-mono text-[8.5px] uppercase tracking-[0.16em] text-gold-dim" data-id="element-166" data-mp="9fmlbfrvalnq">
                Registro de acceso
                <BadgeCheck aria-hidden="true" className="h-3 w-3 text-gold" data-id="element-167" data-mp="1230jfh7axn9f" />
              </p>
              <p className="mt-1 truncate text-[12.5px] font-bold text-bone" data-id="element-168" data-mp="xbr0t0k67k71">
                {item.name} · {item.city}
              </p>
              <p className="truncate text-[11.5px] text-ash" data-id="element-169" data-mp="sc612nx6f7t9">
                Aseguró el arsenal completo por{' '}
                <span className="font-bold text-gold" data-id="element-170" data-mp="1ptmiwk38pz7t">$11.99</span>
              </p>
              <p className="mt-1 font-mono text-[9px] uppercase tracking-[0.14em] text-white/30" data-id="element-171" data-mp="1l0tg41rc10yd">
                Hace {item.minutesAgo} min · Verificado
              </p>
            </div>

            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificaciones de compra" className="-mr-0.5 -mt-0.5 self-start rounded p-1 text-white/30 transition-colors hover:text-white/70 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-gold" data-id="element-172" data-mp="1xcvr4a00frva">
              <X className="h-3.5 w-3.5" data-id="element-173" data-mp="2gaosv8ywdvr3" />
            </button>
          </div>

          <motion.span key={`${item.id}-bar`} initial={{
        scaleX: 1
      }} animate={{
        scaleX: 0
      }} transition={{
        duration: VISIBLE_MS / 1000,
        ease: 'linear'
      }} aria-hidden="true" className="mt-2.5 block h-[2px] origin-left rounded-full bg-[linear-gradient(90deg,#d4af37,#ff2f92)]" data-id="element-174" data-mp="2g8lyydumjih3" />
        </motion.div> : null}
    </AnimatePresence>;
}